module.exports = __webpack_public_path__ + "static/streets-2-bf5cb5cf514edb36175fbfc9a6f5f97f.svg";